import { createFileRoute } from "@tanstack/react-router";
import { CopySharedWishlistRoute } from "./-wishlistDeepLink";

export const Route = createFileRoute("/copySharedWishlist")({
  component: CopySharedWishlistRoute,
});
